import React from "react"
import Select from "react-select"
import PPUtils from "../../utils/PPUtils"

function applyCustomerSelection(selectedOption) {
    if (selectedOption == null) {
        return false
    }

    const auth = PPUtils.getLogin()
    if (auth == null) {
        return false
    }

    const isAdminSelf = selectedOption.value === auth.token_original
    const nextCustomerId = selectedOption.customerId
    if (!isAdminSelf && !PPUtils.isValidCustomerId(nextCustomerId)) {
        return false
    }

    auth.token = selectedOption.value
    auth.token_name = selectedOption.label
    auth.token_rights = selectedOption.rights

    if (isAdminSelf) {
        if (auth.customer) {
            auth.customer.id = undefined
            auth.customer.user = undefined
        } else {
            auth.customer = { id: undefined }
        }
    } else if (auth.customer) {
        auth.customer.id = nextCustomerId
        const selectedCustomerUser = auth.customerUsers?.find(
            (customerUser) => customerUser.token === selectedOption.value
        )
        if (selectedCustomerUser?.user) {
            auth.customer.user = selectedCustomerUser.user
        }
    } else {
        const selectedCustomerUser = auth.customerUsers?.find(
            (customerUser) => customerUser.token === selectedOption.value
        )
        auth.customer = {
            id: nextCustomerId,
            user: selectedCustomerUser?.user
        }
    }

    const label = typeof selectedOption.label === "string" ? selectedOption.label : ""
    if (label.toLocaleLowerCase().indexOf("sylphen") >= 0) {
        auth.user.frontendUploadImport = ""
    } else {
        auth.user.frontendUploadImport = selectedOption.frontendUploadImport
    }
    PPUtils.updateLogin(auth)
    return true
}

function PPSelectCustomers(props) {
    let auth = PPUtils.getLogin()
    let customers = []

    if (auth?.user == null) {
        return ""
    }

    if (auth.user.rights == "admin" && auth.customerUsers?.length >= 1) {
        if (!auth.token_original) {
            auth.token_original = auth.token
            PPUtils.updateLogin(auth)
        }

        customers = auth.customerUsers.reduce(function (previous, current) {
            return previous.concat({
                value: current.token,
                label: current.customer.name,
                rights: current.user.rights,
                customerId: PPUtils.customerIdFromCustomerUser(current),
                configShowTablePreset: current.user.configShowTablePreset,
                frontendUploadImport: current.user.frontendUploadImport
            })
        }, [])
        customers.unshift({
            value: auth.token_original,
            label: auth.user.name,
            rights: auth.user.rights,
            configShowTablePreset: auth.user.configShowTablePreset,
            frontendUploadImport: auth.user.frontendUploadImport
        })
        let selectedValue = customers.find((e) => e.value == auth.token)

        return (
            <div id="sidebar-customers">
                <form>
                    <Select
                        id="selectCustomers"
                        options={customers}
                        onChange={(selectedOption) => {
                            const applied = applyCustomerSelection(selectedOption)
                            if (!applied) {
                                return
                            }
                            props.changePresetId(selectedOption.configShowTablePreset)
                            window.location.reload()
                        }}
                        isClearable={false}
                        name="selectcustomers"
                        value={selectedValue}
                    />
                </form>
            </div>
        )
    }

    return ""
}

export { applyCustomerSelection }

export default PPSelectCustomers
